import Reveal from "@/components/feature/Reveal";
import { featureList } from "@/mocks/homeContent";

export default function FeatureWall() {
  const [lead, ...rest] = featureList;

  return (
    <section id="wall" className="bg-background-50">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <div className="flex items-end justify-between gap-4 border-b border-background-200/80 pb-5">
            <div>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
                今晚这几条，先看这版
              </h2>
              <p className="mt-2 text-sm text-foreground-600 md:text-base">
                大图只给最值得点开的那条，其余按热度往下排。
              </p>
            </div>
            <a
              href="#timeline"
              className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600 md:flex"
            >
              按时间看全部
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </a>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7" delay={60}>
            <a href="#wall" className="group block cursor-pointer">
              <div className="relative h-56 w-full overflow-hidden rounded-lg border border-background-200 bg-background-100 sm:h-72 md:h-[360px]">
                <img
                  src={lead.image}
                  alt={lead.title}
                  title={`${lead.title} 黑料六点 傍晚爆料`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  {lead.badge}
                </span>
              </div>
              <div className="mt-5">
                <span className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-600">
                  {lead.tag}
                </span>
                <h3 className="mt-3 font-heading text-xl font-semibold leading-snug text-foreground-950 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                  {lead.summary}
                </p>
                <p className="mt-4 text-xs text-foreground-500">{lead.meta}</p>
              </div>
            </a>
          </Reveal>

          <div className="flex flex-col gap-5 lg:col-span-5">
            {rest.map((item, index) => (
              <Reveal key={item.id} delay={140 + index * 70}>
                <a
                  href="#wall"
                  className="group flex cursor-pointer items-stretch gap-4 rounded-lg border border-background-200 bg-background-100/60 p-3 transition-colors hover:border-primary-300 md:p-4"
                >
                  <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md border border-background-200 bg-background-200/50 sm:h-24 sm:w-32">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={`${item.title} 黑料六点 晚间吃瓜`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                    />
                  </div>
                  <div className="flex flex-1 flex-col">
                    <span className="text-xs text-secondary-700">{item.tag}</span>
                    <h3 className="mt-1.5 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-foreground-950 md:text-[15px]">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 hidden text-xs leading-relaxed text-foreground-500 sm:block">
                      {item.summary}
                    </p>
                    <p className="mt-auto pt-2 text-xs text-foreground-400">{item.meta}</p>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}